import { z } from 'zod';

export enum ProdutoTipoAlteracao {
    PrecoCusto = 1,
    PrecoMedio = 2,
    PrecoVenda = 3,
    PrecoVendaPacote = 4,
    PrecoVendaAdicional = 5,
}

export const ProdutoAlteracaoPrecoSchema = z.object({
    alp_data_insercao: z.string(),
    alp_descricao: z.string().nullable(),
    alp_empresa_idpk: z.number(),
    alp_idpk: z.number(),
    alp_preco_antigo: z.number(),
    alp_preco_novo: z.number(),
    alp_produto_adicional_item_idpk: z.string().nullable(),
    alp_produto_idpk: z.number(),
    alp_produto_pacote_barra_idpk: z.number().nullable(),
    alp_tipo: z.enum(ProdutoTipoAlteracao),
    alp_usuario_idpk: z.number().nullable(),
    alp_usuario_nome: z.string().nullable(),
});

export type ProdutoAlteracaoPreco = z.infer<typeof ProdutoAlteracaoPrecoSchema>;
